import { createActions } from 'redux-actions';

export const {
  getAllExecutors,
  getAllExecutorsSuccess,
  getAllExecutorsFailure,
  getFilterExecutors,
  getFilterExecutorsSuccess,
  getFilterExecutorsError,
} = createActions(
  'GET_ALL_EXECUTORS',
  'GET_ALL_EXECUTORS_SUCCESS',
  'GET_ALL_EXECUTORS_FAILURE',
  'GET_FILTER_EXECUTORS',
  'GET_FILTER_EXECUTORS_SUCCESS',
  'GET_FILTER_EXECUTORS_ERROR'
);
